import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import "../../css/coupon/ManageCouponHistory.css";
import "../../css/Manage.css";
import moment from "moment";
import CouponApi from "../../api/couponApi";
import { toast } from "react-toastify";
import { saveAs } from "file-saver";

const ManageCouponHistory = () => {
  let navigate = useNavigate();
  const { page } = useParams();
  const location = useLocation();

  const [searchParams, setSearchParams] = useSearchParams();

  const [historyList, setHistoryList] = useState([]);
  const [filteredList, setFilteredList] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [pageIndex, setPageIndex] = useState([]);
  const [postsPerPage, setPostsPerPage] = useState(10);

  useEffect(() => {
    setSearchKeyword(
      searchParams.get("keyword") ? searchParams.get("keyword") : ""
    );
    setCurrentPage(Number(page));
    getHistoryList();
  }, [currentPage, location]);

  const getHistoryList = async () => {
    try {
      const historyInfo = (await CouponApi.GetUsageHistory()).data.data.content;
      setHistoryList(historyInfo);

      // 검색어가 있으면 필터링
      const keyword = searchParams.get("keyword");
      const filtered = keyword
        ? historyInfo.filter(
            (item) =>
              item.couponName?.includes(keyword) ||
              item.memberName?.includes(keyword) ||
              item.memberEmail?.includes(keyword)
          )
        : historyInfo;

      setFilteredList(filtered);
      setTotalCount(filtered.length);

      const count = Math.ceil(filtered.length / postsPerPage / 4);
      for (let i = 1; i <= count; i++) {
        if (currentPage / 4 <= i) {
          setStartIndex(4 * (i - 1));
          return;
        }
      }
    } catch (error) {
      console.log(error);
      toast("서버에 문제가있습니다. 잠시후 다시 시도해주세요.");
    }
  };

  useEffect(() => {
    let page = Math.ceil(totalCount / postsPerPage);
    let arr = [];
    for (var i = 1; i <= page; i++) {
      arr.push(i);
    }
    setPageIndex(arr);
  }, [totalCount]);

  // 엑셀 다운로드
  const downloadExcel = async () => {
    const Excel = require("exceljs");
    const workbook = new Excel.Workbook();
    workbook.addWorksheet("Sheet One");
    const sheetOne = workbook.getWorksheet("Sheet One");

    sheetOne.columns = [
      { header: "쿠폰명", key: "couponName", width: 40 },
      { header: "회원명", key: "memberName", width: 20 },
      { header: "회원 이메일", key: "memberEmail", width: 30 },
      { header: "타입", key: "type", width: 15 },
      { header: "공간명", key: "spaceName", width: 30 },
      { header: "사용일자", key: "usedAt", width: 20 },
    ];

    filteredList.map((item, index) => {
      sheetOne.addRow({
        couponName: item.couponName || "-",
        memberName: item.memberName || "-",
        memberEmail: item.memberEmail || "-",
        type:
          item.couponType === "RESIDENCY"
            ? "거주권"
            : item.couponType === "MEETING"
            ? "모임"
            : "공간",
        spaceName: item.spaceCategoryTitle || "-",
        usedAt: item.usedAt
          ? moment(item.usedAt).local().format("YYYY-MM-DD HH:mm:ss")
          : "-",
      });
    });

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "쿠폰 사용 내역.xlsx");
  };

  // 현재 페이지에 표시할 데이터
  const getCurrentPageData = () => {
    const startIdx = (currentPage - 1) * postsPerPage;
    const endIdx = startIdx + postsPerPage;
    return filteredList.slice(startIdx, endIdx);
  };

  return (
    <div className="Manage-container">
      <section className="Manage-contents Manage-contents-table">
        <span>쿠폰 사용 내역</span>
        <div className="manage-table-container">
          <div className="Manage-coupon-history-search-container">
            <div className="Manage-coupon-history-search-number">
              <span>전체</span>
              <span>{totalCount}</span>
            </div>
            <div className="Manage-coupon-history-search">
              <div style={{ position: "relative" }}>
                <input
                  className="table-search-input"
                  type="text"
                  placeholder="검색어를 입력하세요"
                  onChange={(e) => {
                    setSearchKeyword(e.target.value);
                  }}
                  value={searchKeyword}
                />
                <img
                  src="/img/search.svg"
                  alt=""
                  style={{
                    position: "absolute",
                    right: "10px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    navigate(
                      `/admin/coupon/usage-history/1?keyword=${searchKeyword}`
                    );
                  }}
                />
              </div>

              <div onClick={downloadExcel} className="cursorPointer">
                <img src="\img\download.svg" />
                <span>엑셀로 내보내기</span>
              </div>
            </div>
          </div>
          <div className="Manage-table manage-table-coupon-history">
            <table>
              <thead>
                <tr>
                  <th>쿠폰명</th>
                  <th>회원명</th>
                  <th>회원 이메일</th>
                  <th>타입</th>
                  <th>공간명</th>
                  <th>사용일자</th>
                </tr>
              </thead>
              <tbody>
                {getCurrentPageData().map((item, index) => {
                  return (
                    <tr key={index}>
                      <td>{item.couponName || "-"}</td>
                      <td>{item.memberName || "-"}</td>
                      <td>{item.memberEmail || "-"}</td>
                      <td>
                        {item.couponType === "RESIDENCY"
                          ? "거주권"
                          : item.couponType === "MEETING"
                          ? "모임"
                          : "공간"}
                      </td>
                      <td>{item.spaceName || ""}</td>
                      <td>
                        {item.usedAt
                          ? moment(item.usedAt)
                              .local()
                              .format("YYYY/MM/DD HH:mm")
                          : "-"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="manage-table-pagenation-container">
              <div className="manage-table-pagenation">
                <a
                  onClick={() => {
                    if (currentPage <= 1) {
                      return;
                    } else {
                      navigate(
                        `/admin/coupon/usage-history/${
                          currentPage - 1
                        }?keyword=${searchKeyword}`
                      );
                    }
                  }}
                >
                  <img src="\img\chevron-left.svg" />
                </a>
                {pageIndex
                  .slice(startIndex, startIndex + 4)
                  .map((item, index) => {
                    return (
                      <a
                        key={index}
                        className={
                          currentPage === item ? "pagenation-focus" : null
                        }
                        onClick={() => {
                          navigate(
                            `/admin/coupon/usage-history/${item}?keyword=${searchKeyword}`
                          );
                        }}
                      >
                        {item}
                      </a>
                    );
                  })}
                <a
                  onClick={() => {
                    if (currentPage >= pageIndex.length) {
                      return;
                    } else {
                      navigate(
                        `/admin/coupon/usage-history/${
                          currentPage + 1
                        }?keyword=${searchKeyword}`
                      );
                    }
                  }}
                >
                  <img src="\img\chevron-right.svg" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ManageCouponHistory;
